import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Minimal data-fetching hook: refetches when `deps` change, `reload()` refetches on demand.
 * Swap for TanStack Query when the app grows (caching, polling, mutations).
 */
export function useApi(fetcher, deps = []) {
  const fetcherRef = useRef(fetcher)
  useEffect(() => {
    fetcherRef.current = fetcher
  })

  const [state, setState] = useState({ data: null, error: null, loading: true })
  const [version, setVersion] = useState(0)
  const key = JSON.stringify(deps)

  useEffect(() => {
    let cancelled = false
    fetcherRef
      .current()
      .then((data) => !cancelled && setState({ data, error: null, loading: false }))
      .catch((error) => !cancelled && setState((s) => ({ ...s, error, loading: false })))
    return () => {
      cancelled = true
    }
  }, [key, version])

  const reload = useCallback(() => setVersion((v) => v + 1), [])
  return { ...state, reload }
}
